import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ResponseModelInterfaceStatic } from "../response-model-interface";
import { DrugHead } from "./drug-common/head/drug-head";
import { DrugHistory } from "./drug-model-detail/history/drug-history";
import { DrugModelLight } from "./drug-model-detail/drug-model-light";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugModelDetail
{
    public constructor(
        public history: DrugHistory,
        public head: DrugHead,
        public model: DrugModelLight,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugModelDetail
    {
        return new DrugModelDetail(
            DrugHistory.makeFromXml(elem.firstChildByTag("history")),
            DrugHead.makeFromXml(elem.firstChildByTag("head")),
            DrugModelLight.makeFromXml(elem.firstChildByTag("drugModel"))
        );
    }
}
